import { jsx as r } from "react/jsx-runtime";
import t from "react";
const a = "InclusionsDrawerContent-module_drawer__vztWT",
  o = "InclusionsDrawerContent-module_wrapper__WX3FA",
  e = {
    drawer: a,
    wrapper: o
  },
  p = _ref => {
    let {
      children: n
    } = _ref;
    return /* @__PURE__ */r("div", {
      className: e.drawer,
      children: /* @__PURE__ */r("div", {
        className: e.wrapper,
        children: /* @__PURE__ */r(t.Fragment, {
          children: n
        })
      })
    });
  };
export { p as InclusionsDrawerContent };